import type { QueriesObject, QueryResults, System } from '../../odie';

import { app } from '../app';
import { BlockComponent } from '../components/BlockComponent';
import type { BlockEntity, CageBlockEntity } from '../entities/BlockEntity';
import { despawnBlockEntity } from '../entities/BlockEntity';
import type { GameScene } from '../GameScene';
import { mapGetPan } from '../util/mapTools';
import { isPowerBlock } from '../util/matchTools';
import { CageBlockEffect } from '../actions/effects/CageBlockEffect';

/*
    handles cage blocks
*/
export class CageBlockSystem implements System {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockCage';
  public static Queries: QueriesObject = {
    block: {
      components: [BlockComponent],
      removed: true,
    },
  };

  // fields
  //-------------------------------------------------------------------------
  // injected
  public scene!: GameScene;
  public queries!: QueryResults;

  // impl
  //-------------------------------------------------------------------------
  public removedFromQuery(entity: BlockEntity) {
    if (this.scene.isApplyingExtraPowerups) return;
    // handle block cleared
    this._onBlockCleared(entity);
  }

  // private: events
  //-------------------------------------------------------------------------
  private _onBlockCleared(entity: BlockEntity) {
    // clear any cages over destroyed block
    this._clearCageOverBlock(entity);
  }

  // private: actions
  //-------------------------------------------------------------------------
  //TODO: handle via collider
  private _clearCageOverBlock(entity: BlockEntity) {
    const mapComponent = this.scene.sessionEntity.c.map;
    const position = entity.c.position.mapPosition;

    // get overlay block entity (if any) at given block's position
    const overlayBlock = mapComponent.getCellAt(position)?.overlay?.entity;
    const overBasicBlock = entity.c.block.blockId.includes('basic');
    const overPowerupBlock = isPowerBlock(entity);

    // if cage overlay on block
    if (
      overlayBlock?.c.block.blockId === 'cage' &&
      overlayBlock?.c.view2d.view.visible &&
      (overBasicBlock || overPowerupBlock)
    ) {
      // play sound
      app.sound.play('puzzle-bubble-destroy', { pan: mapGetPan(position) });

      const effect = new CageBlockEffect(this.scene, {
        entity: overlayBlock as CageBlockEntity,
      });
      effect.animateBreak();

      // despawn cage block
      despawnBlockEntity(this.scene, overlayBlock);
    }
  }
}
